import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Projects";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Contact from "../components/Contact";
// import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="bg-white">
      <Navbar />
      <Hero />
      <About />
      <Projects />
      <Services />
      <Gallery />
      <Contact />
      {/* <Footer /> */}
    </div>
  );
};

export default Home;
